import HowDoesCCSWork from './web-component/HowDoesCCSWork'

function App () {
  return (
    <div className='bg-grey50'>
      <div className='asset mx-auto max-w-[1200px]'>
      <HowDoesCCSWork />
    </div>
    </div>
  )
}

export default App
